const lineHeight = {
    xxxxl: '48px',
    xxxl: '44px',
    xxl: '30px',
    xl: '28px',
    l: '24px',
    m: '20px',
    s: '18px',
    xs: '16px',
    xxs: '14px',
}

export default lineHeight
export type LineHeight = typeof lineHeight
